// Web entry (W1.web-frame takes over from W0): mounts the app shell with the real API client.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { createApiClient } from './api/client.ts';

const container = document.getElementById('root');
if (!container) throw new Error('SONNET KM web: #root element missing');

createRoot(container).render(
  <StrictMode>
    <App api={createApiClient({ baseUrl: '/api' })} />
  </StrictMode>,
);
